import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import "./style.css";

import { AuthLayout } from '../../Components/Layout/AuthLayout';
import CustomButton from '../../Components/CustomButton';
import CustomInput from "../../Components/CustomInput"
import { useLoginMutation } from '../../Redux/Apis/Auth';
import { isEmail, objectValidator } from '../../Utils';

let initialState = {
    email: null,
    password: null
}

const AdminLogin = () => {

    const navigate = useNavigate()
    const [login, { data, isLoading, isSuccess }] = useLoginMutation();

    const [formData, setFormData] = useState(initialState)

    useEffect(() => {
        document.title = 'The Turn At | Login';
    }, [])

    useEffect(() => {
        if (isSuccess) {
            if (data?.data?.mustChangePassword) {
                navigate('/profile/change-password', {
                    replace: true,
                    state: { forcePasswordChange: true }
                })
                return
            }

            navigate('/vendor-requests', { replace: true })
        }
    }, [data, isSuccess, navigate])

    const handleClick = (e) => {

        e.preventDefault()

        if (objectValidator(formData) && isEmail(formData.email)) {
            login(formData)
        }

    }

    return (
        <>
            <AuthLayout authTitle='Sign In' authPara='Login to The Turn At Admin'>
                <form>
                    <CustomInput value={formData?.email} label='Email Address' required id='userEmail' type='email' placeholder='Enter Your Email Address' labelClass='mainLabel' inputClass='mainInput' onChange={(event) => {
                        setFormData({ ...formData, email: event.target.value })
                    }} />
                    <CustomInput value={formData?.password} label='Password' required id='pass' type='password' placeholder='Enter Password' labelClass='mainLabel' inputClass='mainInput' onChange={(event) => {
                        setFormData({ ...formData, password: event.target.value })
                    }} />
                    <div className="d-flex align-items-baseline justify-content-end mt-1">
                        <Link to={'/forget-password'} state={{ email: formData.email }} className='text-dark text-decoration-underline'>Forget Password?</Link>
                    </div>
                    <div className="mt-4 text-center">
                        <CustomButton variant='primaryButton' text='Login' onClick={handleClick} loading={isLoading} />
                    </div>
                </form>
            </AuthLayout>
        </>
    )
}


export default AdminLogin
